import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import type { ComponentType, SVGProps } from 'react';
import { CheckMark } from '@/components/icons/CheckMark';
import { InfinityIcon } from '@/components/icons/Infinity';
import { Protect } from '@/components/icons/Protect';
import { Sparkle } from '@/components/icons/Sparkle';
import { Styleguide } from '@/components/icons/Styleguide';
import { Support } from '@/components/icons/Support';
import { Team } from '@/components/icons/Team';
import { Version } from '@/components/icons/Version';
import { Workflow } from '@/components/icons/Workflow';
import { cn } from '@/lib/styles';
const iconMap: Record<NonNullable<Data.Component<'shared.pricing-plan-highlight'>['icon']>, ComponentType<SVGProps<SVGSVGElement>>> = {
  checkmark: CheckMark,
  sparkle: Sparkle,
  infinity: InfinityIcon,
  support: Support,
  styleguide: Styleguide,
  team: Team,
  version: Version,
  workflow: Workflow,
  protect: Protect
};
export function HighlightIcon(t0) {
  const $ = _c(6);
  const {
    icon,
    className
  } = t0;
  const Icon = icon && iconMap[icon] ? iconMap[icon] : CheckMark;
  const t1 = icon !== "sparkle" && "text-peach-500";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn("size-5 top-0.5 relative shrink-0 mr-2", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== Icon || $[4] !== t2) {
    t3 = <Icon aria-hidden={true} className={t2} />;
    $[3] = Icon;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}